import { AlertMetadata } from '../../store/state';
import { RootState } from '..';
import { useSelector } from 'react-redux';

export const useGetAppStatuses = (): AlertMetadata[] =>
  useSelector((state: RootState) => state.AppStatus.alerts);
